<template>
    <c-dialog ref="dialog" mode="slide" width="70vw" mask-close
              @close="dialogFormEditConfirm($refs.handoverForm, arguments)">
        <c-form ref="handoverForm" column="3" vertical unit-width="100%">
            <c-form link-parent>
                <c-form-item label="调拨类型" required>
                    <c-radio-group name="handover_type" v-model="handoverType" :options="handoverTypeDic"></c-radio-group>
                </c-form-item>
                <c-form-item label="接收部门" required>
                    <c-select name="handover_dept_id" v-model="departmentId" async @search="searchDepartment"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_department_edit')" @click="$refs.departmentEdit.open()">创建部门</c-link>
                    </template>
                </c-form-item>
                <c-form-item label="接驳人" required>
                    <c-select ref="userSelect" name="handover_user_id" v-model="handoverUserId" async @search="searchUser" :disabled="!departmentId"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_sysuser_edit')"  @click="$refs.sysuserEdit.open()">添加用户</c-link>
                    </template>
                </c-form-item>
                <c-form-item label="调拨备注">
                    <c-input type="textarea" name="remark" maxlength="200"></c-input>
                </c-form-item>
            </c-form>
            <c-title>调拨商品明细</c-title>
            <c-form-item :label="false" name="product_list" colspan="3">
                <m-operate border>
                    <c-input ref="codeInput" name="purchase_code" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanCodeHandle">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
                    <c-button color="main" @click="scanCodeHandle">确定</c-button>
                    <c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
                </m-operate>
                <c-table ref="productTable" :data="scannedList" border :paging="false">
                    <template #empty>
                        <c-empty message="请扫描产品背贴码"></c-empty>
                    </template>

                    <c-table-column type="selector" width="40"></c-table-column>
                    <c-table-column label="产品信息" width="300">
                        <template #default="{data}">
                            <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                        </template>
                    </c-table-column>
<!--                    <c-table-column label="背贴码" width="130">-->
<!--                        <template #default="{data}">{{data.produce_unique_code}}</template>-->
<!--                    </c-table-column>-->
<!--                    <c-table-column label="IMEI" width="160">-->
<!--                        <template #default="{data}">{{data.produce_imei || '-'}}</template>-->
<!--                    </c-table-column>-->
                    <c-table-column label="成本价" width="90">
                        <template #default="{data}"><span class="price-text">{{data.cost_price ? '¥' + data.cost_price : '-'}}</span></template>
                    </c-table-column>
<!--                    <c-table-column label="当前接驳人" width="100">
                        <template #default="{data}">{{data.handover_user_name || '-'}}</template>
                    </c-table-column>-->
                    <c-table-column label="商品主状态" width="100">
                        <template #default="{data}">
                            <c-state v-if="data.state" tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                            <span v-else class="status-tag">已入库</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="入库时间" width="150">
                        <template #default="{data}">{{data.first_stock_in_time || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="操作" width="80" type="button">
                        <template #default="{data}">
                            <c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
                <!-- 已扫码列表 -->
            </c-form-item>
        </c-form>
        <template #button>
            <c-button color="main" prepend-icon="tf-export" size="dialog" @click="submitHandle(true)">确认并导出明细</c-button>
            <c-button color="main" size="dialog" @click="submitHandle(false)">确定</c-button>
            <c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
        </template>
        <!--创建/编辑部门弹窗-->
        <department-edit ref="departmentEdit"></department-edit>
        <!--创建/编辑用户弹窗-->
        <sysuser-edit ref="sysuserEdit"></sysuser-edit>
    </c-dialog>
</template>

<script>
import departmentEdit from "@/pages/system/department_edit.vue";
import sysuserEdit from "@/pages/system/sysuser_edit.vue";
import scanCodeGuard from '@/mixins/scan_code_guard';

export default {
    name: 'purchaseOrderEdit',
    components: {departmentEdit,sysuserEdit},
    mixins: [scanCodeGuard],

    props: {
        /**允许扫码加入的商品子状态（默认在库；多源直调可传 12质检中/22维修中/32销售中）*/
        allowStates: {
            type: Array,
            default: () => [10]
        },
        /**弹窗标题*/
        dialogTitle: {
            type: String,
            default: '批量调拨'
        }
    },

    data() {
        return {
            handoverType:0,
            departmentId:0,
            handoverUserId:0,
            scanCode: '',          //背贴码
            scannedList: [],       //已加载的唯一码列表
            handoverTypeDic:[]
        }
    },

    watch: {
        //切换接收部门后清空已选接驳人，防止部门与接驳人不一致（清成空值而非0，否则必填校验会把0当作已选）
        departmentId(val, oldVal) {
            if (val != oldVal && this.handoverUserId) {
                this.handoverUserId = '';
                this.$refs.userSelect && this.$refs.userSelect.set();
            }
        }
    },

    methods: {
        /*******搜索调拨类型（含当前模块自身类型）****************/
        searchHandoverType(keyword, resolve) {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code:'HANDOVER_TYPE',
                    keyword: keyword
                },
                success: data => {
                    this.handoverTypeDic = data;
                }
            })
        },
        /*******搜索部门*****************/
        searchDepartment(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'DEPARTMENT',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },
        /*******搜索用户*****************/
        searchUser(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SYSUSER',
                    department_id:this.departmentId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },

        /*********聚焦输入框**********/
        focusInput() {
            this.$nextTick(() => {
                var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
                if (input) input.focus();
            });
        },

        /*********【背贴码】扫码处理**********/
        scanCodeHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            if (this.scannedList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已扫描', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            //防止连续点击【确定】对同一背贴码并发请求，导致已扫列表重复录入
            if (this.isScanCodePending(code)) {
                this.$message({message: '该背贴码正在校验，请勿重复提交', type: 'warn'});
                return;
            }
            this.lockScanCode(code);
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code
                },
                success: (data) => {
                    if (this.allowStates.includes(Number(data.state))){
                        this.pushScannedItem(data, code);
                    }else {
                        this.$message({message: '背贴码【'+code+'】当前状态无法调拨', type: 'warn'});
                    }
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (msg) => {
                    this.$message({message: '背贴码不存在或已被删除，请检查', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                },
                complete: () => {
                    this.unlockScanCode(code);
                }
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*********移除已扫项**********/
        removeItem(data) {
            this.scannedList = this.scannedList.filter(item => item.id != data.id);
            this.focusInput();
        },

        /*********批量移除选中项**********/
        batchRemove() {
            let selectedList = this.$refs.productTable.getData('selected');
            if (!selectedList || selectedList.length == 0) {
                this.$message({message: '请先勾选要移除的记录', type: 'warn'});
                return;
            }
            var ids = selectedList.map(item => item.id);
            this.scannedList = this.scannedList.filter(item => !ids.includes(item.id));
            this.focusInput();
        },

        //打开弹窗
        open(list) {
            this.searchHandoverType();
            this.scannedList = [];
            //清空表单数据
            this.$refs.handoverForm.clear();
            this.$refs.dialog.open({
                title: this.dialogTitle
            });
            if (list && list.length > 0){
                list.forEach(item => {
                    this.scanCode = item.produce_unique_code
                    this.scanCodeHandle();
                });
            }
            //自动定位到【背贴码输入框】
            this.focusInput();
        },

        /*******提交编辑数据（exportDetail=true 时提交成功后导出本次调拨明细）********************/
        submitHandle(exportDetail) {
            var product_list = this.$refs.productTable.getData();
            if (!product_list || product_list.length == 0){
                this.$message({
                    message: '请至少输入一个调拨商品',
                    type: 'warn'
                });
                return false;
            }

            this.$refs.handoverForm.submit({
                url: '/handover/batch/add',
                rule: {
                    handover_type: '请选择调拨类型',
                    handover_dept_id: '请选择接收部门',
                    handover_user_id: '请选择接驳人'
                },
                dataFormatter: data => {
                    //产品列表
                    let produce_unique_id_list = product_list.map(item => {
                        return item.id;
                    });
                    data.produce_unique_id_list = produce_unique_id_list;
                    return data;
                },
                success: (data, res) => {
                    this.$message({
                        type: 'success',
                        message: '调拨成功',
                    });
                    //刷新页面
                    this.$emit('resolve');
                    this.$refs.dialog.close();
                    //确认并导出明细：res 为后端回传的本次接驳记录ID，按该ID集合导出调拨明细
                    if (exportDetail && res && res.length) {
                        this.exportHandoverDetail(res);
                    }
                }
            });
        },

        /*********导出调拨明细（与调拨明细导出链路同端点同下载方式）**********/
        exportHandoverDetail(handover_ids) {
            this.request({
                url: '/handover/product/export/url',
                data: {
                    handover_ids: handover_ids
                },
                loading: true,
                success: data => {
                    if (data && data.url) {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        });
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.section-title {
    display flex
    align-items center
    margin 12px 0 8px
    .title-icon {
        width 4px
        height 16px
        background #1890ff
        border-radius 2px
        margin-right 8px
    }
    .c-title {
        margin 0
    }
}
.scan-toolbar {
    padding 3px 3px
    background #fafafa
    border 1px solid #e8e8e8
    border-bottom 0
    border-radius 4px 4px 0 0
    > * + * {
        margin-left 10px
    }
    .scan-input-box {
        position relative
        width 260px
        /deep/ .c-input input {
            background #fffbe6
            padding-right 32px
        }
        .scan-icon {
            position absolute
            right 10px
            top 50%
            transform translateY(-50%)
            color #999
            cursor pointer
        }
    }
}
.empty-state {
    padding 60px 0
    text-align center
    color #999
    .empty-icon {
        color #ccc
    }
    p {
        margin-top 10px
        font-size 14px
    }
}
.product-info {
    display flex
    align-items center
    gap 8px
    .level-tag {
        display inline-block
        padding 2px 5px
        border-radius 4px
        background #f5f5f5
        color #333
        font-size 12px
        line-height normal
        white-space nowrap
    }
    .product-text {
        flex 1
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
    }
}
.price-text {
    color #333
    text-decoration underline
}
.status-tag {
    display inline-block
    padding 2px 5px
    border-radius 4px
    background #e6f7e6
    color #2ebc78
    font-size 12px
    line-height normal
    white-space nowrap
}
</style>